import { OrganizationEmailDialog } from 'components/purchase/OrganizationEmailDialog'
import { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useUserCurrentQuery } from 'services/users'

interface Props extends PropsWithChildren {}

const withEmailCheck = (WrappedComponent: FunctionComponent<Props>) => {
  return (props: Props) => {
    const [isOrgEmailModalOpen, setOrgEmailModalOpen] = useState<boolean>(false)
    const location = useLocation()
    const { data: user, refetch } = useUserCurrentQuery()
    const isPortalRoute = location.pathname.includes('/portal')

    useEffect(() => {
      if (user) {
        if (!user.organizationEmail) {
          setOrgEmailModalOpen(true)
        }
      }
    }, [user])

    const handleClose = () => {
      setOrgEmailModalOpen(false)
      refetch()
    }

    if (isPortalRoute && isOrgEmailModalOpen) {
      return (
        <OrganizationEmailDialog open={isOrgEmailModalOpen} onClose={handleClose} />
      )
    }

    return <WrappedComponent {...props} />
  }
}

export default withEmailCheck
